import React from 'react';
import { ShoppingCart, Plus } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 bg-amber-50 border-y border-amber-100" data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-3">
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-4">
            <div className="relative" data-id="element-5">
              <div className="absolute -top-4 -right-4 bg-red-500 text-white font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-6">
                GRATIS
              </div>
              <div className="bg-white p-8 rounded-full border-4 border-amber-200 shadow-xl w-48 h-48 flex items-center justify-center" data-id="element-7">
                <ShoppingCart className="h-20 w-20 text-amber-500" data-id="element-8" />
              </div>
            </div>
          </div>

          <div className="w-full md:w-2/3" data-id="element-9">
            <div className="flex items-center gap-2 text-amber-600 font-bold mb-2 uppercase tracking-wide" data-id="element-10">
              <Plus className="h-5 w-5" data-id="element-11" />
              <span data-id="element-12">Bonus Exclusivo</span>
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-13">
              La Guía de Desinflamación del "Supermercado Latino"
            </h2>
            <p className="text-lg text-slate-700 mb-6" data-id="element-14">
              Olvídate de suplementos caros de farmacia. Te daré la lista de
              compras exacta (Cúrcuma, caldos, semillas) para que sanes por
              centavos al día.
            </p>
            <ul className="space-y-3" data-id="element-15">
              <li className="flex items-center gap-3 text-slate-700" data-id="element-16">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-17"></span>
                Recetas fáciles y económicas.
              </li>
              <li className="flex items-center gap-3 text-slate-700" data-id="element-18">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-19"></span>
                Ingredientes que ya conoces y amas.
              </li>
              <li className="flex items-center gap-3 text-slate-700" data-id="element-20">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-21"></span>
                Desinflama tu cuerpo desde adentro.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}